export const SOURCE_LABELS = {
  workout: { label: 'Workout', path: '/workouts/' },
  completedWorkout: { label: 'Activity', path: '/completedWorkouts/' },
  plan: { label: 'Plan', path: '/trainingplans/' }
}

export function getSourceMeta (entityType) {
  return SOURCE_LABELS[entityType] || null
}
